import type { JapanVehicleAndMiscPricingValues } from "@slfinrtl/ui-bff-routes"
import type { CheckboxFieldProps } from "../../../form/checkbox/CheckboxField"
import type { InputFieldProps } from "../../../form/input/InputField"

export interface JapanVehicleAndMiscPricingFields {
	automobileTax: InputFieldProps
	inspectionRegistration: InputFieldProps
	inspectionRegistrationAgencyFee: InputFieldProps
	liabilityInsurance: InputFieldProps
	lightVehicleTaxEnvironmentalPerformanceLevy: InputFieldProps
	minimumPrice: InputFieldProps
	parkingCertificate: InputFieldProps
	parkingCertificationAcquisitionAgencyFee: InputFieldProps
	purchasePrice: InputFieldProps
	recyclingFee: InputFieldProps
	tonnageTax: InputFieldProps
	vatDeductible: CheckboxFieldProps
	vehiclePrice: InputFieldProps
}

type FieldName = keyof JapanVehicleAndMiscPricingValues

const minimumPriceName: FieldName = "minimumPrice"
const purchasePriceName: FieldName = "purchasePrice"
const vehiclePriceName: FieldName = "vehiclePrice"
const automobileTaxName: FieldName = "automobileTax"
const tonnageTaxName: FieldName = "tonnageTax"
const lightVehicleTaxEnvironmentalPerformanceLevyName: FieldName = "lightVehicleTaxEnvironmentalPerformanceLevy"
const liabilityInsuranceName: FieldName = "liabilityInsurance"
const recyclingFeeName: FieldName = "recyclingFee"
const inspectionRegistrationName: FieldName = "inspectionRegistration"
const inspectionRegistrationAgencyFeeName: FieldName = "inspectionRegistrationAgencyFee"
const parkingCertificateName: FieldName = "parkingCertificate"
const parkingCertificationAcquisitionAgencyFeeName: FieldName = "parkingCertificationAcquisitionAgencyFee"
const vatDeductibleName: FieldName = "vatDeductible"

export const japanVehicleAndMiscPricingFieldNames = {
	automobileTaxName,
	inspectionRegistrationAgencyFeeName,
	inspectionRegistrationName,
	liabilityInsuranceName,
	lightVehicleTaxEnvironmentalPerformanceLevyName,
	minimumPriceName,
	parkingCertificateName,
	parkingCertificationAcquisitionAgencyFeeName,
	purchasePriceName,
	recyclingFeeName,
	tonnageTaxName,
	vatDeductibleName,
	vehiclePriceName,
}
